import { LoadingOutlined } from "@ant-design/icons";
import { Spin } from "antd";
import React from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

const TitleText = styled.div`
  font-size: 20px;
  font-weight: 600;
  color: #1e1e1e;
  text-align: center;
  display: flex;
  align-item: center;
  justify-content: center;
  gap: 8px;
`;

const Text = styled.div`
  font-size: 16px;
  font-weight: 500;
  color: #7a7a7a;
  text-align: center;
`;

const Card = styled.div`
  width: 400px;
  margin: 0 auto;
  padding: 32px;
  margin: 24px auto;
  display: flex;
  flex-direction: column;
  gap: 16px;
  border-radius: 16px;
  border: 1px solid #eaeaea;
  box-shadow: 0px 4px 16px 0px rgba(0, 0, 0, 0.1);
`;
const Processing = () => {

  const {t} = useTranslation();

  return (
    <div style={{ height: "70vh", display: "flex", alignItems: "center" }}>
      <Card>
        <TitleText>
          <Spin
            indicator={<LoadingOutlined spin />}
            size="medium"
            style={{ fontWeight: 700 }}
          />
          {t('processing')}
        </TitleText>
        <Text>
          {t('process_your_transaction')}
        </Text>
      </Card>
    </div>
  );
};

export default Processing;
